import React from "react";
import {
	Table,
	TableRow,
	TableHead,
	TableBody,
	TableCell,

	Box,
	Grid,
	Skeleton,
	Pagination,
	IconButton,
} from "@mui/material";
import {
	makeStyles
} from "@mui/styles";
import {
	KeyboardArrowUp as KeyboardArrowUpIcon,
	KeyboardArrowDown as KeyboardArrowDownIcon
} from "@mui/icons-material";
import {
	VisibleContent
} from "../../../../../components";
import moment from "moment";
import clsx from "clsx";

const CustomTable = (props) => {
	const {
		items,
		filter,
		isLoading,
		totalPages,
		onChangePage
	} = props;
	const classes = useStyles();

	const handleChangePage = (event, newPage) => {
		onChangePage({
			...filter,
			page: newPage
		}, true)
	}

	return (
		<>

			<Box className={classes.root}>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell width={40}/>
							<TableCell>Номер заявки</TableCell>
							<TableCell>Клиент</TableCell>
							<TableCell>Исполнитель</TableCell>
							<TableCell>VIN</TableCell>
							<TableCell>Пробег</TableCell>
							<TableCell align="right">Дата создания</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						<VisibleContent visible={!isLoading}>
							{items.map((item) => (
								<RowItem
									key={`RowItem-${item.id}`}
									item={item}
								/>
							))}
						</VisibleContent>
						<VisibleContent visible={isLoading}>
							<RowsLoading/>
						</VisibleContent>
					</TableBody>
				</Table>

				<VisibleContent visible={totalPages > 1}>
					<Box mt={2}/>
					<Grid container justifyContent="flex-end">
						<Grid item>
							<Pagination
								page={filter.page}
								count={totalPages}
								onChange={handleChangePage}
							/>
						</Grid>
					</Grid>
				</VisibleContent>
			</Box>

		</>
	)
};
const RowItem = ({ item }) => {
	const classes = useStyles();

	const [isOpen, setOpen] = React.useState(false);
	const KeyboardArrowIcon = Boolean(isOpen) ? KeyboardArrowUpIcon : KeyboardArrowDownIcon;
	const handleChangeOpen = () => {
		setOpen(!isOpen);
	}

	return (
		<>
			<TableRow
				className={clsx({
					'--open': isOpen
				})}
			>
				<TableCell>
					<IconButton onClick={handleChangeOpen}>
						<KeyboardArrowIcon/>
					</IconButton>
				</TableCell>
				<TableCell>{ item?.triceps_order_id || "Н/Д" }</TableCell>
				<TableCell>{ item?.client || "Н/Д" }</TableCell>
				<TableCell>{ item?.mechanic || "Н/Д" }</TableCell>
				<TableCell>{ item?.vin || "Н/Д" }</TableCell>
				<TableCell>{ item?.mileage || "Н/Д" }</TableCell>
				<TableCell align="right">{moment(item.created_at).format("DD.MM.YYYY HH:mm:ss")}</TableCell>
			</TableRow>
			<VisibleContent visible={isOpen}>
				<TableRow>
					<TableCell colSpan={7}>
						<Grid container spacing={2}>
							<VisibleContent visible={Boolean(item.message)}>
								<Grid item xs={12}>
									<div className={classes.sectionTitle}>Сообщения</div>
									<div dangerouslySetInnerHTML={{__html: item.message}} className={classes.sectionMessage}/>
								</Grid>
							</VisibleContent>
							<VisibleContent visible={(item.files || []).length > 0}>
								<Grid item xs={12}>
									<div className={classes.sectionTitle}>Фото/видео фиксация</div>
									<div className={classes.sectionImages}>
										<Grid container spacing={2}>
											{(item.files || []).map((file) => (
												<Grid item xs={2}>
													<a
														target="_blank"
														href={file.url}
														className={classes.sectionIframe}
													><img src={file.url}/></a>
												</Grid>
											))}
										</Grid>
									</div>
								</Grid>
							</VisibleContent>
						</Grid>
					</TableCell>
				</TableRow>
			</VisibleContent>
		</>
	)
}
const RowsLoading = React.memo(() => {
	return new Array(10).fill(1).map((t) => (
		<TableRow>
			<TableCell><Skeleton/></TableCell>
			<TableCell><Skeleton/></TableCell>
			<TableCell><Skeleton/></TableCell>
			<TableCell><Skeleton/></TableCell>
			<TableCell><Skeleton/></TableCell>
			<TableCell><Skeleton/></TableCell>
			<TableCell><Skeleton/></TableCell>
		</TableRow>
	))
})

const useStyles = makeStyles(() => ({
	root: {
		padding: 10,
		borderRadius: 10,
		background: "white",

		"& .MuiTableRow-root.--open .MuiTableCell-body": {
			'border-bottom-color': 'transparent'
		},
		"& .MuiTableRow-root.--back-effect .MuiTableCell-root": {
			background: "#DFEDCE",
			"&:first-child": {
				borderRadius: "10px 0 0 10px"
			},
			"&:last-child": {
				borderRadius: "0 10px 10px 0"
			},
		},
		"& .MuiTableHead-root .MuiTableCell-head": {
			fontSize: "12px",
			lineHeight: "100%",
			letterSpacing: "-0.02em",
			color: "#647083",
			fontWeight: "400",
			padding: "8px",
			border: "none"
		},
		"& .MuiTableBody-root .MuiTableCell-body": {
			fontSize: "16px",
			lineHeight: "100%",
			letterSpacing: "-0.02em",
			color: "#152435",
			fontWeight: "400",
			padding: "16px 8px",
			border: "none",
			borderBottom: "1px solid rgba(21, 36, 53, 0.1)"
		},
	},

	sectionTitle: {
		marginBottom: 4,
		fontSize: 16,
		color: "black",
		lineHeight: 1.2,
		fontWeight: "600"
	},
	sectionIframe: {
		width: "100%",
		display: "flex",
		borderRadius: 10,
		cursor: "pointer",
		overflow: "hidden",
		position: "relative",
		background: "rgba(0,0,0,0.02)",
		border: "1px solid rgba(0,0,0,0.1)",

		"& img": {
			top: 0, left: 0,
			position: "absolute",
			objectFit: "contain",
			width: "100%", height: "100%"
		},
		"&:after": {
			content: "''",
			float: "left",
			paddingTop: "75%",
		}
	},
	sectionImages: {},
	sectionMessage: {
		fontSize: 14,
		opacity: 0.8,
		color: "black",
		lineHeight: 1.2,
		fontWeight: "500"
	},
}));

export default CustomTable
